var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = { cardError: true }, _obj[("cardError--" + _vm.type)] = true, _obj )},[_c('span',[_vm._v(_vm._s(_vm.text))]),(_vm.action)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('action-click')}}},[_vm._v(_vm._s(_vm.action))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }